
<form [formGroup]="createHorseForm" (ngSubmit)="createHorseSubmitted()" class="space-y-3">

  <div class="flex-col sm:flex-row flex gap-3">
    <div class="flex-1">
      <label for="name" class="block text-sm font-semibold leading-6 text-gray-900">Name</label>
      <div class="mt-2">
        <input formControlName="name" type="text" name="name" id="name"
          class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
          placeholder="Horse name">
      </div>
    </div>

    <div class="flex-1">
      <label for="location" class="block text-sm/6 font-medium text-gray-900">Status</label>
      <div class="mt-2 grid grid-cols-1">
        <select id="status" name="status" formControlName="status" class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pl-3 pr-8 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
          <option 
      *ngFor="let status of horseStatuses" 
      [ngValue]="status"
    >
      {{ status | humanizeStatus}}
    </option>
        </select>
        <svg class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon">
          <path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
        </svg>
      </div>
    </div>
   
  </div>

  <div class="flex-col sm:flex-row flex gap-3">

  <div class="flex-1">
    <label for="height" class="block text-sm font-semibold leading-6 text-gray-900">Height</label>
    <div class="relative mt-2 rounded-md shadow-sm">

      <input type="number" formControlName="height" name="height"
        class="block w-full rounded-md border-0 py-1.5 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6">
      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <span class="text-gray-500 sm:text-sm">hh</span>
      </div>
    </div>
  </div>

  <div class="flex-col sm:flex-row flex-1">
    <label for="age" class="block text-sm font-semibold leading-6 text-gray-900">Age</label>
    <div class="mt-2">
      <input formControlName="age" type="number" name="age" id="height"
        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
        placeholder="Age">
    </div>
  </div>

</div>

<div class="flex gap-3">

  <div class="flex-1">
    <label for="breed" class="block text-sm font-semibold leading-6 text-gray-900">Breed</label>
    <div class="mt-2">
      <input formControlName="breed" type="text" name="breed" id="breed"
        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
        placeholder="Breed">
    </div>
  </div>

  <div class="flex-1">


    <legend class="text-sm font-semibold leading-6 text-gray-900">Sex</legend>
    
    <div class="mt-6 space-y-6 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
      <div class="flex items-center">
        <input formControlName="sex" value="Gelding" id="email" name="sex" type="radio" checked
          class="h-4 w-4 border-gray-300 text-accent focus:ring-accent">
        <label for="email" class="ml-3 block text-sm font-medium leading-6 text-gray-900">Gelding</label>
      </div>
      <div class="flex items-center">
        <input formControlName="sex" value="Mare" id="sms" name="sex" type="radio"
          class="h-4 w-4 border-gray-300 text-accent focus:ring-accent">
        <label for="sms" class="ml-3 block text-sm font-medium leading-6 text-gray-900">Mare</label>
      </div>
      <div class="flex items-center">
        <input formControlName="sex" value="Stallion" id="push" name="sex" type="radio"
          class="h-4 w-4 border-gray-300 text-accent focus:ring-accent">
        <label for="push" class="ml-3 block text-sm font-medium leading-6 text-gray-900">Stallion</label>
      </div>
    </div>

  </div>

</div>

  <div>
    <label for="colour" class="block text-sm font-semibold leading-6 text-gray-900">Colour</label>
    <div class="mt-2">
      <input formControlName="colour" type="text" name="colour" id="colour"
        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"
        placeholder="Colour">
    </div>
  </div>












  <div>

    <fieldset formGroupName="disciplines">
      <legend class="text-sm font-semibold leading-6 text-gray-900">Disciplines</legend>
      <div class="grid grid-cols-2 gap-3">
        <div *ngFor="let discipline of disciplines" class="relative flex items-start">
          <div class="flex h-6 items-center">
            <input [formControlName]="discipline" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-accent focus:ring-accent">
          </div>
          <div class="ml-3 text-sm leading-6">
            <label class="font-medium text-gray-900">{{ discipline }}</label>
          </div>
        </div>
      </div>
    </fieldset>



  </div>

  <br>

  <div class="relative flex items-start">
    <div class="flex h-6 items-center">
      <input formControlName="isAffiliated" type="checkbox"
        class="h-4 w-4 rounded border-gray-300 text-accent focus:ring-accent">
    </div>
    <div class="ml-3 text-sm leading-6">
      <label for="comments" class="font-medium text-gray-900">Horse is affiliated</label>
    </div>
  </div>
  
  <div>
    <label for="comment" class="block text-sm font-medium leading-6 text-gray-900">Notes</label>
    <div class="mt-2">
      <textarea rows="4" formControlName="notes"  class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"></textarea>
    </div>
  </div>



  <div class="button-row">
    <button type="submit"
      class="inline-flex w-full justify-center rounded-md bg-accent px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-accent-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent"
      [disabled]="createHorseForm.invalid"> {{ (modalService.horse) ? "Update Horse" : "Create Horse" }}</button>
  </div>

</form>